import Vuex from 'vuex'
import Vue from 'vue'
/**/
/*import inventoryTurnoverRule from './businessRules/inventoryTurnoverRule/index.js'*/

Vue.use(Vuex)
const state = {
  userInfo: JSON.parse(sessionStorage.getItem("USER_INFO")) || {},
  menuActive: "1",
  menuOpeneds: ["1"],
  currentLanguage: sessionStorage.getItem("CURRENT_LANGUAGE") || '2',
  // userInfo:{
  //   uid:'',
  //   uname:'',
  //   rid:'',
  //   rname:'',
  //   // client_key:'',
  //   // company:'',
  //   // role:'',
  //   // roleStr:'',
  //   // token:'',
  //   // os: '0',
  //   // pageType:'login',
  //   // linkToType:'',
  // },
  // linkTo:'/home',
}
const getters = {
  uid: state => state.userInfo.uid || '',
  unum: state => state.userInfo.unum || '',
  uname: state => state.userInfo.uname || '',
  uename: state => state.userInfo.uename || '',
  urole: state => state.userInfo.urole || '',
  menuActive: state => state.menuActive,
  menuOpeneds: state => state.menuOpeneds,
  currentLanguage: state => state.currentLanguage,
  // rid: state => state.userInfo.rid,
  // rname: state => state.userInfo.rname,
  // company:state=>state.userInfo.company,
  // role:state=>state.userInfo.role,
  // roleStr:state=>state.userInfo.roleStr,
  // client_key:state=>state.userInfo.client_key,
  // token:state=>state.userInfo.token,
  // os:state=>state.userInfo.os,
  // pageType:state=>state.userInfo.pageType,
  // linkToType:state=>state.userInfo.linkToType,

  // linkTo:state=>state.linkTo,

}
const actions = {

}
const mutations = {
  userInfoInit: (state, payload) => {
    state.userInfo.uid = payload.id;
    state.userInfo.unum = payload.num;
    state.userInfo.uname = payload.name;
    state.userInfo.uename = payload.ename;
    state.userInfo.urole = payload.role;
    // state.userInfo.rname = payload.rname;
    // state.userInfo.company = payload.company;
    // state.userInfo.role = payload.role;
    // state.userInfo.roleStr = payload.roleStr;
    // state.userInfo.client_key = payload.client_key;
    // state.userInfo.token = payload.token;
  },
  menuChange: (state, payload) => {
    state.menuActive = payload.menuActive;
    state.menuOpeneds = payload.menuOpeneds;
  },
  // linkToTypeFun:(state,payload)=>{
  //   state.userInfo.linkToType = payload.linkToType;
  // },

  // routerLink: (state, payload) => {
  //     state.linkTo = payload.linkTo;
  // },
  changeLanguage: (state, payload) => {
    state.currentLanguage = payload.language;
    sessionStorage.setItem("CURRENT_LANGUAGE", payload.language);
  }
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  // modules: {
  /*业务规则*/
  // inventoryTurnoverRule,
  // }
})



// WEBPACK FOOTER //
// ./src/store/index.js